/**
 * submit-on-change.js
 * Submit the form if the element is changed
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */
;(function($) {

    "use strict";

    $(function() {
        /**
         * Submit function via Ajax
         *
         * @param  Elemnt
         * @return Void
         */
        var submitOnChange =function(e, f){
            // Locate the nearest form and trigger submit
            $(this.closest('form')).trigger('submit');
        };

        /**
         * Inputs marked with "data-submit-on-change" attribute will trigger the form submit
         */
        $(':input[data-submit-on-change]').change(submitOnChange);
    });

})(window.jQuery);
